export default {
  partNoPlaceholder: 'Wybierz numer części',
};
